import React, { RefObject, useContext } from 'react';

import { adminTableHeaders } from '../../../Tables/tabsConfig';

export enum PageType {
  LIST = 'list',
  DETAIL = 'detail'
}

export type TableContext = {
  contentNodeForButtons: RefObject<HTMLDivElement>;
  context: {
    page: string;
    type: PageType;
    setPageType: React.Dispatch<PageType>;
  };
};

export const tableContext = React.createContext<TableContext>({
  contentNodeForButtons: { current: null },
  context: {
    page: adminTableHeaders[0].tabs[0].name,
    type: PageType.LIST,
    setPageType: () => null
  }
});

const useTableContext = () => useContext<TableContext>(tableContext);

export default useTableContext;
